/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { ICON_WARNING } from '../../Icons';
import { SdsIcon } from '../SdsIcon';
import { ErrorMessageProps, errorMessageDefaults } from './ErrorMessage.props';

/**
 * SDS Error Message component.
 */
export const ErrorMessage = (props: ErrorMessageProps): JSX.Element => {
  const { classes, contained, message } = {
    ...errorMessageDefaults,
    ...props,
  };

  const errorClass = clsx(`sds-error`, classes, {
    [`sds-error--contained`]: contained,
  });

  return (
    <div className={errorClass}>
      <SdsIcon svg={ICON_WARNING} />
      <span>{message}</span>
    </div>
  );
};
